import styled from '@emotion/styled'




export const AudienceOuter = styled.div({
  padding: '56px 40px 40px',
}, props => ({
}))

export const AudienceTitle = styled.h3({
fontSize: 16,
fontWeight: 600,
lineHeight: '28px',
margin: '0 0 12px'
})

export const AudienceBox = styled.div({
  marginBottom: '32px'
})

export const AudienceLabel = styled.h3({
fontSize: 14,
fontWeight: 600,
lineHeight: '24px',
margin: '0 0 16px',
position: 'relative',
paddingRight: 30
})

export const EditDemButton = styled.div({
position: 'absolute',
right: 0,
top: 0
})

export const DemsWrapper = styled.div({
  background: '#F5F5F5',
  padding: '16px',
  border: '1px solid #e9e8e8',
  borderRadius: 12
})

export const CountryFlag = styled.div({
  width: 24,
  height: 24,
  borderRadius: '50%',
  overflow: 'hidden',
  display: 'inline-block',
  verticalAlign: 'middle',
   marginRight: 12,
  '& img': {
    width: '100%',
    objectFit: 'cover',
    height: '100%'
  }
})

export const CountryRegion = styled.span({
  display: 'inline-block',
  verticalAlign: 'middle',
  fontSize: 15,
  flex: 1
})

export const CountryLanguage = styled.span({
  display: 'inline-block',
  verticalAlign: 'middle',
  background: '#F5F5F5',
  padding: '0 8px',
  border: '1px solid #e9e8e8',
  borderRadius: 30,
  fontSize: 14,
  marginLeft: 12,
  float: 'right'
})


export const ChipLabel = styled.div({
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
})

export const ChipLabelDems = styled.span({
  fontWeight: 500
})